import { render, staticRenderFns } from "./in_process_product.vue?vue&type=template&id=2673f33a&scoped=true"
import script from "./in_process_product.vue?vue&type=script&lang=js"
export * from "./in_process_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673f33a",
  null
  
)

export default component.exports